module.exports = __webpack_public_path__ + "static/media/11.31646afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/11.png
// module id = 1293
// module chunks = 0